import React, { useState } from "react";
import { Loader2 } from "lucide-react";
import axiosApi from "../server/service";
import { useNavigate } from "react-router-dom";
import { useUserStore } from "../store/AuthUserStore";



// --- THE MAIN LOGIN COMPONENT ---
export default function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const setUser = useUserStore((state) => state.setUser);

  const navigate = useNavigate();

  const handleLogin = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setIsLoading(true);
    setError(null);

    try {
      const response = await axiosApi.post("/api/auth/login", {
        username,
        password,
      });

      // ✅ Extract token and user info from response
      const { token, user } = response.data;

      // Save JWT token to localStorage
      localStorage.setItem("token", token);

      setUser(user);

    if (user.userRole === "employee" && user.employeeType === "Group Work") {
        // If the user is a 'Group Work' employee, send them to the new dashboard
        navigate("/group-work-dashboard");
      } else if (user.userRole === "employee") {
        // For all other employee types
        navigate("/employeedashboard");
      } else {
        // For admins and supervisors
        navigate("/");
      }

    // Redirect to dashboard

      // navigate("/");


    } catch (err: any) {
      const errorMessage =
        err.response?.data?.message ||
        "Login failed. Please check your credentials.";
      setError(errorMessage);
      setUsername("");
      setPassword("");
      console.error("Login error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="bg-slate-100 flex items-center justify-center min-h-screen">
      <div className="bg-white shadow-xl rounded-2xl p-8 max-w-sm w-full">
        <div className="text-center mb-6">
          <h1 className="text-2xl font-bold text-slate-800">Little LilyERP</h1>
          <p className="text-slate-500 mt-1">Sign in to your account</p>
        </div>

        <form onSubmit={handleLogin}>
          <div className="mb-4">
            <label
              htmlFor="username"
              className="block text-sm font-medium text-slate-600 mb-1"
            >
              Username
            </label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter your username"
              className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              required
            />
          </div>

          <div className="mb-6">
            <label
              htmlFor="password"
              className="block text-sm font-medium text-slate-600 mb-1"
            >
              Password
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              required
            />
          </div>

          {error && (
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded-lg mb-4 text-sm">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={isLoading}
            className="w-full bg-green-600 text-white font-semibold py-2.5 rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors duration-300 flex items-center justify-center disabled:bg-green-400"
          >
            {isLoading ? (
              <Loader2 className="animate-spin" size={20} />
            ) : (
              "Sign In"
            )}
          </button>
        </form>
      </div>
    </div>
  );
}
